import { RemoteFilterGroupRenderer } from '@michelin/acid-components';
import { withPropsTransformer, withShouldRenderProp } from "../../../hocs";
const ToolbarFilterFieldsWithShouldRenderProp = withShouldRenderProp(RemoteFilterGroupRenderer);
const filterFieldsPropsTransformer = (inputProps) => {
    return inputProps.data;
};
export const ToolbarFilterFields = withPropsTransformer(filterFieldsPropsTransformer)(ToolbarFilterFieldsWithShouldRenderProp);
//# sourceMappingURL=ToolbarFilterFields.js.map